import { FC, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { Box } from '@qwealth/qcore';
import { selectUserIsAdmin, selectUserIsCompliance } from '@qwealth/qdata';

import { resetComplianceData } from 'data/actions/compliance';
import ComplianceHeader from './Header/ComplianceHeader';
import ComplianceReviewsPage from './ComplianceReviewsPage';
import ComplianceContactPage from './ComplianceContactPage';
import { useAppDispatch, useAppSelector } from 'data/store';
import { complianceRoute } from 'data/refData/compliance';

const CompliancePage: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isUserAdmin = useAppSelector(selectUserIsAdmin);
  const isUserCompliance = useAppSelector(selectUserIsCompliance);
  const canUserViewThisPage = isUserAdmin || isUserCompliance;
  const location = useLocation();
  useEffect(() => {
    return () => {
      dispatch(resetComplianceData());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!canUserViewThisPage && location.pathname.includes(`/${complianceRoute.path}/contact`)) {
      navigate(`/${complianceRoute.path}`);
    }
  }, [canUserViewThisPage, dispatch]);

  return (
    <Box display="flex" flexDirection="column">
      <ComplianceHeader />
      <Routes>
        <Route path="/" element={<ComplianceReviewsPage />} />
        <Route path="household/:householdQID" element={<ComplianceReviewsPage />} />
        {canUserViewThisPage && <Route path="contact/:contactQID/:section?" element={<ComplianceContactPage />} />}
      </Routes>
    </Box>
  );
};

export default CompliancePage;
